module.exports = __webpack_public_path__ + "img/4.c6f7e966.png";